import { PortalMedia } from '@app/core/interfaces/portal-media';
import { PortalNotification, PortalNotificationType } from '@app/core/interfaces/portal-notification';
import { PortalNotificationWithTranslations } from '@app/core/interfaces/portal-notification-with-translations';
import { DateUtils } from '@app/utils/date';
import { MyPortalNotificationViewModel } from '@business/notification/models/my-portal-notifications-view-model';

export interface PortalNotificationLike {
  id: number;
  name: string;
  publishedAt: Date;
  translations: PortalNotificationTranslationLike[];
  type: PortalNotificationType;
}

export interface PortalNotificationTranslationLike {
  content?: string;
  language: string;
  media?: PortalMedia;
  orderIndex: number;
  title?: string;
}

export type SupportedPortalNotification =
  | PortalNotification
  | PortalNotificationLike
  | PortalNotificationWithTranslations
  | MyPortalNotificationViewModel;

function isMyViewModel(value: any): value is MyPortalNotificationViewModel {
  return value != null && '_original' in value;
}

function isPortalNotificationWithTranslations(
  notification: any
): notification is PortalNotificationWithTranslations {
  return notification != null && Array.isArray(notification.translations);
}

export function normalizeNotification(
  notification: SupportedPortalNotification | PortalNotification
): PortalNotificationLike {
  if (isMyViewModel(notification)) {
    return {
      ...notification._original,
      publishedAt: notification.publishedAt,
    };
  } else if (isPortalNotificationWithTranslations(notification)) {
    return {
      ...notification,
      publishedAt: DateUtils.parse(notification.publishedAt),
    };
  } else if (isPortalNotificationWithTranslations(notification)) {
    return {
      ...notification,
      publishedAt: DateUtils.parse(notification.publishedAt),
    };
  } else {
    return {
      ...notification,
      id: notification.id!,
      publishedAt: DateUtils.parse(notification.publishedAt),
      translations: [],
    };
  }
}

/**
 * Returns either the translations for the given language. If it
 * doesn't exist then it will return the first available language.
 */
export function getTranslationsByKey<T>(translationMap: Record<string, T>, language: string): T {
  const byLanguage = translationMap[language];

  if (byLanguage == null) {
    const firstAvailableLanguage = Object.values(translationMap)[0];

    return firstAvailableLanguage;
  }

  return byLanguage;
}
